import React from "react";
import { useNavigate } from "react-router-dom";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import ProductFilterDialogWrapper from "./FilterDialog/ProductFilterDialogWrapper";
import { usePermission } from "src/hooks/usePermission";

type Props = {
  columns: columnTypes[];
  productExcel: () => void;
  templateExcel: () => void;
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
    setIsOpenUploadExcelDialog: (newValue: boolean) => void;
  };
};

const ProductManagementListing = ({
  columns,
  productExcel,
  templateExcel,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
    setIsOpenUploadExcelDialog,
  },
}: Props) => {
  const navigate = useNavigate();
  const canExcelDownload = usePermission(
    "PRODUCT".toLocaleUpperCase(),
    "EXCEL_DOWNLOAD"
  );
  const canExcelUpload = usePermission(
    "PRODUCT".toLocaleUpperCase(),
    "EXCEL_UPLOAD"
  );
  return (
    <SideNavLayout>
      <div className="flex flex-col h-full p-4">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader
            moduleName="PRODUCT"
            pageTitle="Products"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            buttonProps={{
              btnName: "Add New",
              onClick: () => {
                navigate("/product/add");
              },
            }}
            extraButton={true}
            extraButtonProps={[
              {
                btnName: "Download Template",
                onClick: async () => {
                  try {
                    const fileUrl =
                      "https://career-prefix.s3.ap-south-1.amazonaws.com/career-prefix/image/image_1762092951912_20251102194551.xlsx";
                    const link = document.createElement("a");
                    link.href = fileUrl;
                    link.target = "_blank";
                    link.download = "TemplateFile.xlsx";
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                  } catch (error) {
                    console.error("Download failed:", error);
                  }
                },
                className: "w-30",
              },
              ...(canExcelDownload
                ? [
                    {
                      btnName: "Download Excel",
                      onClick: () => productExcel(),
                      className: "w-40",
                    },
                  ]
                : []),
              ...(canExcelUpload
                ? [
                    {
                      btnName: "Upload Excel",
                      onClick: () => setIsOpenUploadExcelDialog(true),
                      className: "w-48",
                    },
                  ]
                : []),
            ]}
          />
        </div>
        <div className="">
          <ProductFilterDialogWrapper />
        </div>
        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col">
          <ATMTable
            columns={columns}
            rows={rows}
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
            onRowClick={(row) => navigate(`/product/${row?._id}`)}
          />
        </div>

        <div className="p-4 py-2">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
      </div>
    </SideNavLayout>
  );
};

export default ProductManagementListing;
